import { Component, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import {
  logout,
  redirectToMarketAuth,
  redirectToMarketAuthWithPretnumerique,
} from './auth';
import BookshopMainSideBar from './components/bookshop/mainSideBar.vue';
import LibraryMainSideBar from './components/library/mainSideBar.vue';
import IconText from './components/shared/iconText.vue';
import MainNavigation from './components/shared/mainNavigation.vue';
import userAcceptMutation from './mutations/userAccept';
import store from './store';
import Welcome from './components/shared/welcome.vue';
import { ViewerContext } from './types/viewer_context';

@Component({
  components: {
    MainNavigation,
    LibraryMainSideBar,
    BookshopMainSideBar,
    IconText,
    Welcome,
  },
})
export default class App extends Vue {
  @Getter public isLoggedStatusResolved?: boolean;
  @Getter public isLogged?: boolean;
  @Getter public loginInformation: any;
  @Getter public isConfirmed?: boolean;
  @Getter public viewerContext?: ViewerContext;

  public loginClickedLibrary(): void {
    redirectToMarketAuthWithPretnumerique();
  }

  public loginClickedBookshop(): void {
    redirectToMarketAuth();
  }

  public async confirmUserClicked(): Promise<void> {
    await this.confirmUser();
  }

  public async cancelUserClicked(): Promise<void> {
    logout();
  }

  /**
   * Call the server to confirm the user accepted the conditions.
   */
  private async confirmUser(): Promise<void> {
    await this.$apollo.mutate({
      mutation: userAcceptMutation,
    });
    this.loginInformation.confirmed = true;
    store.commit('loginInformation', this.loginInformation);
  }
}
